<template>
  <div class="MemberOrder">
    <div class="scanCode">
      <h4>扫码打开{{ isCzScenes ? '成就非凡' : '名师天团' }}APP查看订单</h4>
      <p>请在【APP-我的-我的订单】查看</p>
      <img
        :src="
          isCzScenes
            ? 'https://cdn.yuaiweiwu.com/fe/imgs/9a504430-0532-11ef-98c0-ad176ce97a45-cjff.png'
            : 'https://cdn.yuaiweiwu.com/fe/imgs/96bae870-0532-11ef-98c0-ad176ce97a45-mstt.png'
        "
        class="scanCodeImg"
      />
      <p>使用微信扫码</p>
    </div>
  </div>
  <!-- <div class="MemberOrder">
    <el-tabs class="el-tabs-common" v-model="current" @tab-click="changeTab">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <div class="main" v-if="list.length">
      <div class="header">
        <div class="name">商品名称</div>
        <div class="price">订单金额</div>
        <div class="status">订单状态</div>
        <div class="pay-type">支付类型</div>
        <div class="operate">操作</div>
      </div>
      <div class="item" v-for="item in list" :key="item.order_number">
        <div class="item-header clearfix">
          <span class="f-left">订单编号：{{ item.order_number }}</span>
          <span
            class="red f-left"
            v-if="item.pay_status == 1 && item.order_status == 1"
            style="margin-left: 20px"
          >
            {{
              $store.state.commonSetting.cancel_order_time
            }}分钟内未付款，订单将自动取消
          </span>
          <span class="f-right time">
            下单时间：{{
              new Date(parseInt(item.created_at) * 1000).format(
                "yyyy/MM/dd hh:mm:ss",
              )
            }}
          </span>
        </div>
        <div class="clearfix content">
          <div class="name f-left">
            <el-tooltip
              popper-class="order-name-tips"
              effect="light"
              placement="right"
            >
              <div slot="content">
                <p v-for="(son, index) in item.items" :key="index">
                  {{ son.shop_name }}
                </p>
              </div>
              <span>
                <img
                  v-if="item.order_type == 7"
                  src="~@/assets/images/common/lianbao@2x.png"
                />
                <span>
                  {{ item.spell_id > 0 ? "【拼团】" : "" }}
                  {{ item.title }}
                  <template v-if="item.order_type == 8">
                    {{ " 等 " + item.items.length + "门课程" }}
                  </template>
                </span>
              </span>
            </el-tooltip>
          </div>
          <div class="price f-left">
            <Currency></Currency>
            <span>{{ (item.order_price + item.ship_price) | price }}</span>
          </div>
          <div class="status f-left">
            <div>
              <div>{{ item.status_name }}</div>
              <div
                v-if="
                  item.is_virtual == 2 &&
                  item.order_status == 1 &&
                  item.ship_status == 3
                "
              >
                <div>{{ item.logistics_name }}</div>
                <div>{{ item.logistics_no }}</div>
              </div>
            </div>
          </div>
          <div class="pay-type f-left" v-if="item.pay_type > 0">
            {{ item.pay_type | payType }}
          </div>
          <div class="pay-type f-left" v-else-if="item.pay_status == 2">
            免费
          </div>
          <div class="pay-type f-left" v-else>--</div>
          <div class="operate f-left">
            <div>
              <a @click="showDetail(item.id)">订单详情</a>
            </div>
            <div v-if="item.ship_status != 2">
              <a @click="onOpenAdress(item)">修改收货地址</a>
            </div>
            <div
              v-if="
                item.is_virtual == 2 &&
                item.ship_status == 3 &&
                item.refund_status != 1 &&
                item.refund_status != 2
              "
            >
              <a @click="confirmShip(item.id)">确认收货</a>
            </div>
            <div
              v-if="
                item.shop_type == 12 &&
                (item.ship_status == 2 || item.ship_status == 4) &&
                item.order_status != 3
              "
            >
              <span v-if="item.is_comment == 1">已评价</span>
              <a v-else @click="comment(item)">去评价</a>
            </div>
            <div v-if="item.pay_status == 1">
              <div v-if="item.order_status == 1">
                <a @click="cancelOrder(item)">取消订单</a>
                <div>
                  <el-button type="danger" size="small" @click="goToPay(item)">
                    去支付
                  </el-button>
                </div>
              </div>
              <div v-else-if="item.order_status == 3">
                <span>已取消</span>
              </div>
            </div>
            <a
              v-if="
                (item.pay_status >= 3 && item.pay_status <= 8) ||
                item.refund_status > 0
              "
              @click="onShowRefundDetail(item)"
            >
              退款记录
            </a>
            <div
              v-if="
                item.order_price > 0 &&
                (current == 2 ||
                  current == 4 ||
                  current == 6 ||
                  current == 8) &&
                item.pay_type != 5 &&
                item.pay_type != 6 &&
                item.pay_type != 8 &&
                $store.state.commonSetting.allow_refund == 1 &&
                item.is_can_refund == 1
              "
            >
              <div
                v-if="
                  (item.pay_status == 2 || item.pay_status == 8) &&
                  item.refund_status != 3 &&
                  item.refund_status != 5 &&
                  item.is_overtime == 2
                "
              >
                <a @click="applyRefund(item)">退款</a>
              </div>
              <div v-else>
                <a
                  @click="applyRefund(item)"
                  v-if="
                    (item.pay_status == 2 ||
                      item.pay_status == 6 ||
                      item.pay_status == 8) &&
                    (item.refund_status == 3 ||
                      item.refund_status == 4 ||
                      item.refund_status == 5)
                  "
                >
                  重新发起退款
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="limit"
        layout="prev, pager, next"
        :total="total"
        v-if="total > 15"
      ></el-pagination>
    </div>
    <div v-else class="center" style="padding: 60px 0">暂无订单</div>
    <MemberOrderDetail
      :show.sync="showDetailDialog"
      :detail="detail"
      :current="current"
    ></MemberOrderDetail>
    <el-dialog
      class="comment-dialog"
      title="评价"
      :visible.sync="showCommentDialog"
      width="784px"
    >
      <div class="name item">商品名称：{{ commentDetail.title }}</div>
      <div class="item">
        <label>星级：</label>
        <el-rate
          v-model="commentInfo.grade"
          :disabled="commentDetail.is_comment == 1"
        ></el-rate>
      </div>
      <div class="item">
        <label>评价内容：</label>
        <br />
        <el-input
          type="textarea"
          :rows="6"
          placeholder="请输入评价内容，最多500字"
          v-model="commentInfo.content"
          :maxlength="500"
          :readonly="commentDetail.is_comment == 1"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitComment">保 存</el-button>
      </div>
    </el-dialog>
    <MemberOrderRefund
      ref="refund"
      :current="current"
      @refund="getData"
    ></MemberOrderRefund>
    <MemberOrderRefundDetail ref="refundDetail"></MemberOrderRefundDetail>
    <AddressForm
      ref="form"
      title="修改地址"
      tip="此地址只用于邮寄实体教材，请准确填写"
      @success="chanageSuccess"
      :onConfirm="changeAddress"
      :address="addressInfo"
    ></AddressForm>
  </div> -->
</template>
<script>
import orderFuc from '@/utils/order.js';
// import MemberOrderDetail from "./components/MemberOrderDetail.vue";
// import MemberOrderRefund from "./components/MemberOrderRefund.vue";
// import MemberOrderRefundDetail from "./components/MemberOrderRefundDetail.vue";
// import AddressForm from "../../components/AddressForm.vue";
import { triggerLoaded } from '@/components/LoadContainer.vue';

export default {
  name: 'MemberOrder',
  components: {
    // MemberOrderDetail,
    // MemberOrderRefund,
    // MemberOrderRefundDetail,
    // AddressForm,
  },
  data() {
    return {
      isCzScenes: location.hostname.includes('czmstt'),
      current: this.$route.query.tab || '2',
      list: [],
      showDetailDialog: false,
      detail: {},
      page: 1,
      limit: 15,
      total: 0,
      showCommentDialog: false,
      commentDetail: {},
      commentInfo: {
        grade: 5,
        content: '',
      },
      addressInfo: null,
    };
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    types() {
      let types = [
        {
          type: '2',
          label: '课程订单',
        },
      ];
      if (this.commonSetting.switch_class_module === 1) {
        types.push({
          type: '8',
          label: '班级订单',
        });
      }
      if (this.commonSetting.switch_contract_schedule === 1) {
        types.push({
          type: '6',
          label: '课时包订单',
        });
      }
      if (this.commonSetting.switch_oto_module == 1) {
        types.push({
          type: '1',
          label: '约课订单',
        });
      }
      if (this.commonSetting.switch_goods_module === 1) {
        types.push({
          type: '4',
          label: '实物商品订单',
        });
      }
      if (this.commonSetting.switch_ebook_module === 1) {
        types.push({
          type: '11',
          label: '电子书订单',
        });
      }
      if (this.$store.getters.showVip) {
        types.push({
          type: '9',
          label: '会员订单',
        });
      }
      if (this.commonSetting.switch_question_module === 1) {
        types.push({
          type: '10',
          label: '套卷订单',
        });
      }
      return types;
    },
  },
  watch: {
    async $route() {
      this.page = 1;
      this.current = this.$route.query.tab || '2';
      await this.getData();
    },
  },
  async created() {
    let type = this.$route.query.type;
    if (type) {
      if (type == 1) {
        this.current = '1';
      } else if (type == 14) {
        this.current = '3';
      } else if (type == 12) {
        this.current = '4';
      } else {
        this.current = '2';
      }
    }
    await this.getData();
    triggerLoaded(this);
  },
  methods: {
    onShowRefundDetail(item) {
      this.$refs.refundDetail.show(item);
    },
    applyRefund(item) {
      this.$refs.refund.applyRefund(item);
    },
    async getData() {
      let data = await this.$http.post('/api/app/myOrder', {
        order_type: this.current,
        page: this.page,
        limit: this.limit,
      });
      data.list.forEach((item) => {
        let desc = orderFuc.getListDescData(item);
        let text = desc.text;
        item.status_name = text ? text.list : '';
        item.status_id = desc.id;
        item.is_can_refund =
          item.is_can_refund == 1 &&
          (item.status_id == 3 ||
            item.status_id == 4 ||
            item.status_id == 5 ||
            item.status_id == 6 ||
            item.status_id == 13 ||
            item.status_id == 14);
        if (item.is_virtual == 2 && item.ship_status == 3 && item.auto_confirm_at > 0) {
          item.timer = setInterval(() => {
            if (item.auto_confirm_at == 0) {
              this.autoConfirmShip(item.id);
            }
            item.auto_confirm_at--;
          }, 1000);
        }
        // item.can_refund = 1
        // for(let son of item.items){
        //   if(son.shop_status==3||son.shop_status==6){
        //     item.can_refund = 0
        //     return
        //   }
        // }
      });
      this.list = data.list;
      this.total = data.total;
    },
    async changeTab(item) {
      this.$router.replace({
        name: this.$route.name,
        query: { tab: item.name },
      });
    },
    goToPay(order) {
      this.$router.push({
        name: 'OrderPay',
        params: {
          id: order.id,
        },
        query: {
          type: order.shop_type,
          spell_id: order.spell_id,
        },
      });
    },
    async cancelOrder(item) {
      await this.$confirm('确定要取消订单么？', '提示', {
        type: 'warning',
      });
      await this.$http.post('/api/app/myOrder/cancel', {
        order_id: item.id,
      });
      this.$success('取消成功');
      await this.getData();
    },
    async showDetail(id) {
      this.$router.push({
        name: 'MemberOrderDetail',
        params: { id },
        query: { current: this.current },
      });
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getData();
    },
    async autoConfirmShip(id) {
      await this.$http.put('/api/app/orderShip/confirm/' + id);
      await this.getData();
    },
    async confirmShip(id) {
      await this.$confirm('请收到货物后再点击确认收货，确认收货么？', '提示', {
        type: 'warning',
      });
      await this.autoConfirmShip(id);
    },
    comment(item) {
      this.showCommentDialog = true;
      this.commentInfo.content = '';
      this.commentInfo.grade = 5;
      this.commentDetail = item;
    },
    async submitComment() {
      if (this.commentDetail.is_comment == 1) {
        this.showCommentDialog = false;
        return;
      }
      if (this.commentInfo.grade == 0) {
        await this.$info('请选择星级');
        return;
      }
      if (this.commentInfo.content == '') {
        await this.$info('请输入评价内容');
        return;
      }
      await this.$http.post('/api/app/goods/comment', {
        grade: this.commentInfo.grade,
        content: this.commentInfo.content,
        goods_id: this.commentDetail.shop_ids,
        order_num: this.commentDetail.order_number,
      });
      this.showCommentDialog = false;
      this.commentDetail.is_comment = 1;
      await this.$success('评价成功');
    },
    async onOpenAdress(item) {
      let address = await this.$http.get(`/api/app/address/${item.address_id}`);
      address.orderId = item.id;
      this.addressInfo = address;
      this.$refs.form.showForm();
    },
    changeAddress(params) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        await this.$http.put(`/api/app/myOrder/address/modify/${this.addressInfo.orderId}`, params);
        resolve();
      });
    },
    chanageSuccess() {
      this.$message.success('修改地址成功');
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../css/member-order.scss';
.scanCode {
  padding: 100px 0 300px 0;
  h4,
  p {
    text-align: center;
  }
  h4 {
    margin: 0 0 5px 0;
    font-size: 18px;
  }
  p {
    margin: 10px 0;
  }
  .scanCodeImg {
    display: block;
    width: 105px;
    height: 105px;
    margin: auto;
  }
}
</style>
